import { FC } from 'react'
import { mq } from '@lifedot/styles/mediaQuery'
import Image from 'next/image'
import { css } from '@emotion/react'
import {
  Position,
  cityLinksPrefectures,
  CityLinksPrefecturesKeys
} from './cityLinksPrefectures'
import { CitiesModal } from './CitiesModal'
import { Condition } from '@lifedot/constants/searchChoices'
import { prefectures } from '@lifedot/constants/prefectures'

const style = {
  root: css({
    position: 'relative',
    maxWidth: 560
  }),
  button: (position: Position) =>
    css({
      position: 'absolute',
      ...position.wide,
      [mq('sp')]: {
        ...position.narrow
      }
    })
}

export interface CityLinksProps {
  prefectureRoma: CityLinksPrefecturesKeys
  condition: Condition
}

export const CityLinks: FC<CityLinksProps> = ({
  prefectureRoma,
  condition
}) => {
  const prefectureName = prefectures[prefectureRoma]
  const {
    image: {
      size: { width, height },
      path
    }
  } = cityLinksPrefectures[prefectureRoma]

  return (
    <div css={style.root}>
      <Image
        src={path}
        alt={`${prefectureName}の地図`}
        width={width}
        height={height}
      />
      {cityLinksPrefectures[prefectureRoma].regions.map(
        ({ name, code, position }) => (
          <div key={code} css={style.button(position)}>
            <CitiesModal
              regionCode={code}
              regionName={name}
              prefecture={prefectureRoma}
              condition={condition}
            />
          </div>
        )
      )}
    </div>
  )
}
